import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-student-council',
  templateUrl: './student-council.component.html',
  styleUrls: ['./student-council.component.css']
})
export class StudentCouncilComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

  banner: any = {
    pagetitle: "Student Council",
    bg_image: "assets/images/banner/bnr3.jpg",
    title: "Student Council",
  }
}
